import { genericCallWithBodyAndResponseDecoded, genericGetWithBody, genericGetWithParameters } from "./Networking"

export async function searchBNAdjustments(objCriteria){
    try {
        let response = await genericGetWithBody('BNOrder/SearchOrder',objCriteria);
        return response;
    } catch (error) {
        console.error(error);
    }
}


export async function getBNAdjustment(adjustmentID) {
  try {
    let params = {
      'orderNumber': adjustmentID
    }

    let response = await genericGetWithParameters('BNOrder/GetBankNoteOrder', params);
    return response;
  } catch (error) {
    console.error(error);
  }
}


export async function saveBNAdjustment(objAdjustment) {
  const method = 'POST'
  const apiName = 'BNOrder/SaveOrder'

  const response = await genericCallWithBodyAndResponseDecoded(
    method,
    apiName,
    objAdjustment,
  )
  return response
}

export const voidBNAdjustment = async (adjustmentID) => {
    var method = 'POST';
    var apiName = 'BNOrder/VoidOrder'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'BNOrderNo': adjustmentID
        });
        return response;
    } catch (error) {
        console.error(error)
    }
}
